import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[thirdParty]',
})
export class ThirdPartySectionDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}